// api/index.js
import request from '../util/request'

// ���ɱʼ�
export function generate(data) {
    return request({
        url: '/front/api/design/note/generate/v2',
        method: 'post',
        data: data,
    })
}
export function plusVector(data) {
    return request({
        url: '/front/api/design/note/plus',
        method: 'post',
        data: data,
    })
}

export function deleteProductById(id) {
    return request({
        url: '/front/api/design/product/' + id,
        method: 'delete',
    })
}

export function getDashboardData() {
    return request({
        url: '/front/api/index',
        method: 'get',
    })
}

export function listScoreRecord(param) {
    return request({
        url: '/front/api/design/scorerecord/list',
        method: 'get',
        params: param,
    })
}

export function getScoreByShopId(id) {
    return request({
        url: '/front/api/design/shop/'+id,
        method: 'get',
    })
}

export function deletePicById(id) {
    return request({
        url: '/front/api/design/pic/'+id,
        method: 'delete',
    })
}

export function listNotices() {
    return request({
        url: '/front/api/system/notice/list',
        method: 'get',
    })
}

export function readNotice(noticeId) {
    return request({
        url: '/front/api/design/noticeRead/add?noticeId='+noticeId,
        method: 'post',
    })
}

export function knowledge(prompt) {
    return request({
        url: '/front/api/design/knowledge/stream',
        method: 'post',
        data: {
            prompt: prompt
        }
    })
}

